import {SET_SHOW_SUMMARY} from "../actions/SummaryActions";

const initialState = {
    status: false,
};

export default function SummaryReducer(state = initialState, action) {
    switch (action.type) {
        case SET_SHOW_SUMMARY:
            return {
                status: action.payload,
            }
    }

    return state
}